<template>
  <div class="body" v-bind:class="isLight? 'lightTheme' : 'darkTheme'">
  <div class="mainbar">
  <v-container fluid grid-list-md>
    <v-layout row wrap>

      <v-flex d-flex xs12 sm12 md12 class="firstFlex">

        <div>
          <v-card class="topCard">
            <div class="cardHeaderFirstCard">
               <div class="firstCardTitle darkGreyText">
                   CURRENT PLAN: {{planIsSet? currentPlan  : 'ADD A SAVINGS'}}
               </div>
               <div class="addArea">
                  <v-icon class="plusIcon mr-2 mt-1" v-on:click="addDialog = true">add</v-icon>
               </div>
            </div>


            <div class="chartArea">
                <chartist
                  v-if="names.length > 0"
                  ratio="ct-chart"
                  type="Bar"
                  :data="chartData"
                  :options="chartOptions"
                  :event-handlers="events"
                  id="chart"
                ></chartist>
            </div>

          </v-card>
        </div>

      </v-flex>

      <v-flex d-flex xs12 sm12 md12>
        <div>
          <v-card class="mt-5">
            <v-card-text class="divContainer pt-0 pb-0">
              <div class="leftPart">
                <span class="circle"></span>
                <span class="greyText">Okay</span>
                <span class="circle1"></span>
                <span class="greyText">Advise</span>
              </div>
              <div class="rightPart">
               <span class="greyText">Total: </span>
                <span class="blueText">{{ total }}%</span>
              </div>
            </v-card-text>
          </v-card>
         </div>
      </v-flex>

        <v-flex d-flex xs12 sm6 md4>
        <div class="pt-2 pr-1 card">
          <v-card class="insideCard">
           <div class="cardHeaderFirstCardLower">
               <div class="firstCardTitleLower">
                   <p class="lowerCardHeader">
                     Stats
                   </p>
               </div>
               <!--<div class="addArea">-->

               <!--</div>-->
            </div>



          <div class="lowerCardBody">
            <div v-for="saving of savings" v-if="savings" class="savingsDiv px-3" @click="getSavings(saving)">
              <div class="fullWidth mt-1">
                <div class="floatLeft darkGreyText bigText">
                  {{saving.name}}  <v-chip color="primary" style="color: white" small>
                  {{percentify(saving.currentAmount,saving.targetAmount)}}%
                </v-chip>
                </div>
                <div class="floatRight mediumText" style="display: flex; justify-items: center; align-items: center;">
                  <div class="floatRight blueText">
                    <v-icon color="primary">money</v-icon> {{saving.currentAmount}}
                  </div>

                  <div class="floatRight greenText">
                    /{{saving.targetAmount}}
                  </div>

                </div>
              </div>

              <div v-if="saving.lastTransactionAmount !== '0'" class="fullWidth">
                <span class="floatLeft" v-bind:class="saving.lastTransactionType === 'withdrawal'? 'redText' :
                'greenText'">
                  <span class="greyText">Last: </span>{{ capitalize(saving.lastTransactionType)}} of {{
                  saving.lastTransactionAmount }}
                </span>
              </div>

              <div v-if="saving.lastTransactionAmount !== '0'" class="fullWidth">
                <span class="floatLeft greyText">
                Date: {{ saving.lastTransactionDate}}
                </span>
              </div>
              <v-divider ></v-divider>
               </div>
            </div>
          </v-card>
        </div>
      </v-flex>
      <v-flex d-flex xs12 sm6 md4>
      <div class="pt-2 pr-1 pl-1 card">
        <v-card class="insideCard">
           <div class="cardHeaderFirstCardLower">
               <div class="firstCardTitleLower">
                    <p class="lowerCardHeader">
                     Transactions
                   </p>
               </div>
               <div class="addArea">
                  <v-icon class="cardIcon mr-2 mt-1" @click="search()">search</v-icon>
                  <v-icon class="cardIcon mr-2 mt-1" @click="downloadTransactions()">get_app</v-icon>
               </div>
            </div>

      <div class="lowerCardBody">

         <div class="fullWidth searchBarDiv" v-if="searchBar" v-bind:style="{backgroundColor: isLight?
                'white !important' :
                '#222 !important'}">
           <div class="px-4">
             <v-text-field
               v-model.lazy="searchValue"
               placeholder="Search"
             ></v-text-field>
           </div>
         </div>

          <div class="transactionsDiv px-3 greyText" v-for="transaction of transactions">

            <div class="fullWidth">
              <div class="floatLeft mediumText">
                {{transaction.name}} {{ transaction.transactionType === 'added'? 'added' : ''}}
              </div>
              <div class="floatRight">
                {{ transaction.transactionDate }}
              </div>
            </div>
            <div class="fullWidth"
                 v-bind:class="transaction.transactionType === 'withdrawal'? 'redText': 'greenText'"
                 v-if="transaction.transactionType !== 'added'">
              {{ capitalize(transaction.transactionType)}} of {{ transaction.transactionAmount}}
            </div>
            <div class="fullWidth">
              {{ transaction.transactionID }}
            </div>
            <div class="fullWidth">
              <div class="athird" style="text-align: left;">
                Prev: {{ transaction.prev}}
              </div>
              <div class="athird" style="text-align: center;">
                Current: {{ transaction.current}}
              </div>
              <div class="athird" style="text-align: right">
                Limit: {{ transaction.target }}
              </div>
            </div>
            <v-divider></v-divider>
          </div>

          </div>
        </v-card>
        </div>
      </v-flex>
      <v-flex d-flex xs12 sm12 md4>
        <div class="pt-2 pl-1 card">
            <v-card  class="insideCard">
              <div class="cardHeaderFirstCardLower">
               <div class="firstCardTitleLower">
                    <p class="lowerCardHeader">
                     Advise
                   </p>
               </div>
               <div class="addArea">
                  <v-icon class="cardIcon mr-2 mt-1" @click="downloadAdvise()">get_app</v-icon>
               </div>
            </div>

              <div class="lowerCardBody">
                <div v-if="adviseObject.length > 0" class="fullWidth pa-3 darkGreyText mediumText">
                  Active Savings
                </div>

                <div v-for="advise of adviseObject" class="fullWidth px-3" v-if="adviseObject.length > 0">
                  <div class="fullWidth">
                    <div class="floatLeft greyText">
                      {{advise.name}}
                    </div>
                    <div class="floatRight greyText">
                      {{advise.percentage}}%
                    </div>
                  </div>

                  <div class="fullWidth" v-if="advise.adviseType !== 'OKAY'"
                       v-bind:class="advise.adviseType === 'Withdraw'? 'redText' : 'greenText'">
                    You need to {{ advise.adviseType }} {{ numberfy(advise.adviseAmount) }} to reach the target
                  </div>

                  <v-divider></v-divider>
                  <!--Iterated div-->
                </div>


                <div class="px-3" v-if="adviseObject.length > 0">
                <div class="fullWidth" style="font-size: 14px;">
                  <div class="floatLeft greyText">Current Percentage:</div>
                  <div class="floatRight blueText">{{ numberfy(summaryComponent.total)}}%</div>
                </div>
                  <div class="fullWidth">
                  <div class="floatLeft greyText">Current Savings:</div>
                  <div class="floatRight blueText">{{ summaryComponent.currentTotals}}</div>
                </div>
                  <div class="fullWidth">
                  <div class="floatLeft greyText">Total Savings:</div>
                  <div class="floatRight greenText">{{ summaryComponent.currentTargets}}</div>
                </div>
                  <div class="fullWidth">
                  <div class="floatLeft greyText">Current Plan</div>
                  <div class="floatRight redText">{{ uppercase(summaryComponent.plan)}}</div>
                </div>


                </div>

                </div>
            </v-card>
        </div>

      </v-flex>
      <v-flex d-flex xs12 sm12 md12>
        <div class="insideCard lowerCard pt-2 pb-2">
          <div class="firstIcons">
            <v-icon class="icons"  v-on:click="settingsDialog = true">settings</v-icon>
            <v-icon class="icons ml-4" v-on:click="guideDialog = true">help_outline</v-icon>
            <v-icon class="icons ml-4" v-on:click="info = true">info</v-icon>
          </div>
          <div class="lastIcons">
            <v-icon class="icons" v-on:click="logout()">exit_to_app</v-icon>
          </div>
        </div>
      </v-flex>

    </v-layout>
  </v-container>
    </div>

    <v-dialog
    v-model="settingsDialog"
    max-width="290"
    class="openDialog"

  >
    <v-card class="cardInDialog" v-bind:class="isLight? 'lightCardTheme': 'darkCardTheme'">

      <v-card-title class="headline justify-center dialogTitle">Settings</v-card-title>

      <v-card-text class="content">
        <div>

          <div class="notificationsDiv mt-2 greyText">
            <div class="label">
              <label>Theme: Light</label>
            </div>
            <div class="switch">
              <v-switch
                v-model="themeSwitch"
                class="innerSwitch"
                color="primary"
              ></v-switch>

            </div>
          </div>

          <v-divider class="divider"></v-divider>

          <div class="fullHint greyText">
            <p>
              Change Plan
            </p>
          </div>

          <div class="notificationsDiv mt-2 greyText">
            <v-radio-group v-model.lazy="settingsRadios">

              <div class="radioGroup">


                <div class="full">
                  <div class="toLeft">
                    <label>Conservative</label>
                  </div>

                  <div class="toRight">
                    <v-radio
                      value="conservative"
                      color="primary"
                    ></v-radio>
                  </div>
                </div>

                <div class="full">
                  <div class="toLeft">
                    <label>Equiservative</label>
                  </div>

                  <div class="toRight">
                    <v-radio
                      value="equiservative"
                      color="primary"
                    ></v-radio>
                  </div>
                </div>

                <div class="full">
                  <div class="toLeft">
                    <label>Downward Linear</label>
                  </div>

                  <div class="toRight">
                    <v-radio
                      value="downwardLinear"
                      color="primary"
                    ></v-radio>
                  </div>
                </div>

              </div>
            </v-radio-group>
          </div>

        </div>
      </v-card-text>

      <div class="buttons">
        <v-btn
          color="error"
          flat
          v-on:click="clearData()"
        >
          CLEAR DATA
        </v-btn>
      </div>


      <v-card-actions class="actions">

        <div class="buttons">
          <v-btn
            color="blue"
            flat="flat"
            v-on:click="settingsDialog = false"
          >
            HOME
          </v-btn>
        </div>

      </v-card-actions>

    </v-card>

  </v-dialog>

    <v-dialog
      v-model="addDialog"
      max-width="320"
      class="openDialog"
    >
    <v-card class="cardInDialog addBufferDialog" v-bind:class="isLight? 'lightCardTheme': 'darkCardTheme'">
          <v-card-title class="headline justify-center dialogTitle">Add a Savings</v-card-title>

      <v-form v-model="addValid" lazy-validation ref="form">
        <v-card-text>
        <div class="inputArea dialogTitle">
          <div class="profileInputs">
            <v-text-field
                    label="Title"
                    type= "string"
                    :rules="[titleCheck]"
                    v-model= "title"
                    required
            ></v-text-field>

          </div>

            <div class="profileInputs mt-2">
            <v-text-field
                    label="Savings Goal"
                    type="number"
                    v-model ="target"
                    :rules="number1Rules"
                    required
            ></v-text-field>
          </div>

         <div class="profileInputs mt-2">
            <v-text-field
                    label="Starting Value"
                    type="number"
                    v-model = 'startingValue'
                    :rules="numberRules"
                    required
            ></v-text-field>
          </div>
        </div>

        <div class="planArea" v-if="!planIsSet">
           <v-divider class="divider"></v-divider>

           <div class="fullHint greyText">
              <p>
                Choose Plan
              </p>
           </div>

          <div class="notificationsDiv mt-2 greyText">
                <v-radio-group v-model.lazy="radioGroup" required>

                      <div class="radioGroup">

                      <div class="full">
                        <div class="toLeft">
                         <label>Conservative</label>
                        </div>

                        <div class="toRight">
                         <v-radio
                          value="conservative"
                         ></v-radio>
                        </div>
                    </div>

                    <div class="full">
                        <div class="toLeft">
                         <label>Equiservative</label>
                        </div>

                        <div class="toRight">
                         <v-radio
                          value="equiservative"
                         ></v-radio>
                        </div>
                    </div>

                     <div class="full">
                        <div class="toLeft">
                         <label>Downward Linear</label>
                        </div>

                        <div class="toRight">
                         <v-radio
                          value="downwardLinear"
                         ></v-radio>
                        </div>
                    </div>

                  </div>
                </v-radio-group>

                  <div class="helper">
                    <p v-on:click="switchDialog()">
                      What are these plans?
                    </p>
                 </div>
          </div>
        </div>

        </v-card-text>

            <v-card-actions class="actions">

              <div class="buttons">
               <v-btn
                color="blue"
                flat="flat"
                v-on:click="add()"
              >
                ADD
              </v-btn>

              <v-btn
                color="red"
                flat="flat"
                v-on:click="cancel()"
              >
                CANCEL
              </v-btn>
               </div>

            </v-card-actions>
      </v-form>
      </v-card>

    </v-dialog>

    <v-dialog
      v-model="guideDialog"
      max-width="80vw"
      class="openDialog"
    >
    <v-card class="cardInDialog" v-bind:class="isLight? 'lightCardTheme': 'darkCardTheme'">
      <div class="guideHeader">
        <div class="firstHeader">
          <v-card-title class="headline justify-center pa-0 pt-1 dialogTitle"> Savings App
          </v-card-title>
        </div>
        <div class="lastHeader">
          <v-icon class="guideIcon" v-on:click="guideDialog = false">home</v-icon>
        </div>
      </div>
      <div class="guideBody">
        <v-container fluid grid-list-md>
          <v-layout row wrap>
            <v-flex d-flex xs12 sm6 md4>
              <v-card>
                <img src="@/assets/Conservative.svg" class="guidePic">

                <v-card-title primary-title>
                  <div>
                    <h3 class="headline mb-0 logoTitle">Conservative</h3>

                    <div>...For those who take things one at a time..<br><br>
                      Complete one savings at a time to move on to the next one<br><br>
                      In case you start a new one, you'll be advised to complete previously incomplete savings first before moving forward<br><br>
                      If you withdraw from a previously completed one, you'll be advised to complete it first before adding to subsequent ones or adding a new saving</div>
                  </div>
                </v-card-title>

              </v-card>
            </v-flex>

            <v-flex d-flex xs12 sm6 md4>
              <v-card>
                <img src="@/assets/Equiservative.svg" class="guidePic">

                <v-card-title primary-title>
                  <div>
                    <h3 class="headline mb-0 logoTitle">Equiservative</h3>

                    <div>...For those who need everything at par before moving foward <br><br>
                      The first savings acts as a standard for all <br><br>
                      All savings have to be on the standard level before adding more to the first savings, which is the standard setter<br><br>
                      If you withdraw from the first savings, you'll be advised to withdraw from all the rest to reach the same level</div>
                  </div>
                </v-card-title>

              </v-card>
            </v-flex>

            <v-flex d-flex xs12 sm6 md4>
              <v-card>
                <img src="@/assets/DL.svg" class="guidePic">

                <v-card-title primary-title>
                  <div>
                    <h3 class="headline mb-0 logoTitle">Downward Linear</h3>

                    <div>...For those who give weight to priorities<br><br>
                      The first incomplete savings acts as a gradient setter for all the rest <br><br>
                      It advises you to save more according to your priorities while considering the last priority at the same timeings have to be on the standard level before adding more to the first savings, which is the standard setter<br><br>
                      If you withdraw from a previously completed savings, you'll be advised to withdraw accordingly from all the rest to level your priority gradient</div>
                  </div>
                </v-card-title>

              </v-card>
            </v-flex>

          </v-layout>
        </v-container>
      </div>
      </v-card>

    </v-dialog>

    <v-dialog
      v-model="dialog"
      width="250px"
      persistent>
      <!--<dialog-component :type="type" :message="message" @dismiss="dismiss()"></dialog-component>-->

      <v-card class="alertDialog cardInDialog" v-bind:class="isLight? 'lightCardTheme': 'darkCardTheme'">
        <div v-if="type === 'progress'">
          <v-content>
            <v-progress-circular
              :size="70"
              :width="7"
              color="blue"
              indeterminate
            ></v-progress-circular>
          </v-content>
          <v-card-title class="justify-center">
            <p>
              {{message}}
            </p>
          </v-card-title>
        </div>

        <div v-if="type === 'message'">
          <v-card-title class="justify-center pb-0">
            <p>
              {{message}}
            </p>
          </v-card-title>
          <v-card-actions class="justify-center">
            <v-btn
              color="blue"
              flat="flat"
              v-on:click="dismiss()"
            >
              OK
            </v-btn>
          </v-card-actions>
        </div>

        <div v-if="type === 'messageOnly'">
          <v-card-title class="justify-center pb-0">
            <p>
              {{message}}
            </p>
          </v-card-title>
        </div>
      </v-card>


    </v-dialog>

    <v-dialog
      width="300px"
      v-if="selectedTransactions"
      v-model="transactionsDialog">
      <!--<transactions-dialog :savings="selectedSavings" :transactions="selectedTransactions"-->
                           <!--@dismiss="dismissTransaction()" @update="updateTransaction()"></transactions-dialog>-->

      <v-card style="width: 300px;" class="transactionDialog cardInDialog" v-bind:class="isLight? 'lightCardTheme': 'darkCardTheme'">
        <v-card-text class="greyText">

          <div class="fullWidth blueText bigTitle">
            Transactions
          </div>

          <div class="fullWidth">
            <div class="floatLeft titleText textAlignLeft">{{selectedSavings.name}}</div>
            <div class="floatRight" style="">
              <div style="float: right" class="greenText">/{{selectedSavings.targetAmount}}</div>
              <div style="float: right;" class="blueText">{{selectedSavings.currentAmount}}</div>
            </div>
          </div>

          <v-divider></v-divider>

          <div class="fullWidth">
            <div class="floatLeft titleText textAlignLeft">Transactions:</div>
            <div class="floatRight">{{ selectedTransactions.length - 1 }}</div>
          </div>

          <v-divider></v-divider>

          <div class="fullWidth">
            <div class="floatLeft titleText textAlignLeft">Date Added:</div>
            <div class="floatRight">{{ selectedTransactions[0].transactionDate}}</div>
          </div>

          <v-divider></v-divider>

          <div class="fullWidth">
            Last 6 Transactions
          </div>

          <div class="fullWidth">
            <div v-for="transaction of selectedTransactions">
              <div class="floatLeft textAlignLeft">{{capitalize(transaction.transactionType)}} of
                {{transaction.transactionAmount}}</div>
              <div class="floatRight">{{transaction.transactionDate}}</div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <div class="aThirdRow">
            <div class="aThird">
              <v-btn flat color="blue" @click="updateTransaction">UPDATE</v-btn>
            </div>
            <div class="aThird">
              <v-btn flat color="error" @click="deleteSavings">DELETE</v-btn>
            </div>
            <div class="aThird">
              <v-btn flat color="yellow" @click="dismissTransaction">CANCEL</v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-card>



    </v-dialog>

    <v-dialog
      width="252px"
      v-model="updateDialog">
      <!--<update-dialog :savings="selectedSavings"  @dismiss="dismissUpdate()"></update-dialog>-->

      <v-card class="updateDialog cardInDialog" v-bind:class="isLight? 'lightCardTheme': 'darkCardTheme'">
        <v-form v-model="updateValid" lazy-validation ref="form">
          <v-card-text>

            <div class="notificationsDiv">
              <v-radio-group v-model="transactionType" required>

                <div class="radioGroup">
                  <div class="full">
                    <div class="toLeft">
                      <label class="greyText">Deposit</label>
                    </div>

                    <div class="toRight">
                      <v-radio
                        value="deposit"
                      ></v-radio>
                    </div>
                  </div>

                  <div class="full">
                    <div class="toLeft">
                      <label class="greyText">Withdraw</label>
                    </div>

                    <div class="toRight">
                      <v-radio
                        value="withdrawal"
                      ></v-radio>
                    </div>
                  </div>

                </div>
              </v-radio-group>
            </div>

            <div class="mt-2">
              <v-text-field
                label="Amount"
                type= "number"
                :rules="[checkAmount]"
                v-model= "amount"
                required
              ></v-text-field>
            </div>

            <div class="mt-2">
              <v-text-field
                label="Transaction Code"
                type= "string"
                :rules="transactionRules"
                v-model= "transaction"
                required
              ></v-text-field>
            </div>

          </v-card-text>

          <v-card-actions>
            <div style="float: left; width: 50%;">
              <v-btn flat color="blue" style="width: 100%;" @click="update()">OK</v-btn>
            </div>
            <div style="float: right; width: 50%;">
              <v-btn flat color="error" style="width: 100%;" @click="dismissUpdate()">CANCEL</v-btn>
            </div>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog
      width="400px"
      v-model="info">
      <v-card class="infoCard cardInDialog" v-bind:class="isLight? 'lightCardTheme': 'darkCardTheme'">
        <div class="logosArea">
          <img id="vue" src="../../assets/vue.png" alt="Vue">
          <img id="vuetify" src="../../assets/vuetify.png" alt="Vuetify">
          <img v-if="isLight" class="firebase" src="../../assets/firebase_white.png"
               alt="Firebase">
          <img v-if="!isLight" class="firebase" src="../../assets/firebase_dark.png"
               alt="Firebase">
        </div>

        <v-card-text>
          <div class="paragraph">
            <span class="title">Built using Vue + Vuetify and Firebase</span>
            <br>
            <span class="title2">Much appreciation goes to</span>
            <br>
            <span><b class="vueText">The Vue team</b> - for such an amazingly reactive and easy to use
                   javascript web framework</span>
            <br>
            <span><b class="vuetifyText">The Vuetify team</b> - for a wonderful Material wrapper for vue-apps</span>
            <br>
            <span><b class="firebaseText">The Firebase team</b> - for the fastest online servers for development and
                   testing</span>
            <br><br>
            <span><b class="blueText">Developer:</b> Eliud Arudo</span>
            <br>
            <span><b class="blueText">Contact:</b> eliudarudo@gmail.com</span>
            <br><br>
            <span>For more app-news and guides, check out my
                   <a target="_blank" href="https://fb.me/soderielapps" class="blueText faceBookLink">Facebook page</a></span>
            <br><br>
            <span class="smallerText">&copy2018 All Rights Reserved</span>

          </div>

        </v-card-text>

      </v-card>
    </v-dialog>

  </div>

</template>

<script>
 import router from '@/router'
 import {mapGetters} from 'vuex'
 import firebase from 'firebase';
 import pdfMake from 'pdfmake/build/pdfmake';
 import pdfFonts from 'pdfmake/build/vfs_fonts';
 pdfMake.vfs = pdfFonts.pdfMake.vfs;

 var globalThis = this;

 export default {
   data: () => ({
     info: false,

     isLight: true,
     searchBar: false,
     searchValue: '',
     searchTransactionArray: [],
     total: '',
     chartObject: {},
     advisoryArray: [],
     stackedArray: [],
     selectedSavings: '',
     selectedTransactions: '',
     planIsSet: false,
     currentPlan: null,
     updateDialog: false,
     transactionsDialog: false,
     names: [],
     adviseObject: [],
     summaryComponent: {},
     savings: {},
     transactions: [],
     transactionsSearch: [],
     transactionsOrig: [],
     //Add savings data
     type: '',
     message: '',
     dialog: false,
     addDialog: false,
     addValid: false,
     title:  null,
     target: null,
     startingValue: null,
     radioGroup: '',
     themeSwitch: '',
     settingsRadios: '',


     updateValid: false,
     amount: null,
     transactionType: 'deposit',
     transaction: null,
     transactionRules: [
       v => !!v || 'Code is required'
     ],
     amountRules: [
       v => !!v || 'Please enter a valid amount',
       v => /^[1-9][0-9]{0,200}$/.test(v) || 'Please enter a valid number'
     ],


     titleRules: [
       v => !!v || 'Title is required',
       v => /^[a-zA-Z_\-]+$/.test(v) || 'Spaces and numbers are not allowed'
     ],
     number1Rules: [
       v => !!v || 'Input is required',
       v => /^[1-9][0-9]{0,200}$/.test(v) || 'Target has to be above 0'
     ],
     numberRules: [
       v => !!v || 'Input is required',
       v => /^[0-9]{0,200}$/.test(v) || 'Please enter a valid number'
     ],

     chartData: {
       labels: [],
       series: [[],[]]
     },
     chartOptions: {
       stackBars: true,
       fullWidth: true,
       height: "180px",
       axisY: {
         labelInterpolationFnc: function(value) {
           return Math.round(value * 100) + '%';
         }
       }
     },
     settingsDialog: false,
     guideDialog: false,
     lorem: `Lorem ipsum dolor sit amet, mel at clita quando. Te sit oratio vituperatoribus, nam ad ipsum posidonium mediocritatem, explicari dissentiunt cu mea. Repudiare disputationi vim in, mollis iriure nec cu, alienum argumentum ius ad. Pri eu justo aeque torquatos.Lorem ipsum dolor sit amet, mel at clita quando. Te sit oratio vituperatoribus, nam ad ipsum posidonium mediocritatem, explicari dissentiunt cu mea. Repudiare disputationi vim in, mollis iriure nec cu, alienum argumentum ius ad. Pri eu justo aeque torquatos.Lorem ipsum dolor sit amet, mel at clita quando. Te sit oratio vituperatoribus, nam ad ipsum posidonium mediocritatem, explicari dissentiunt cu mea. Repudiare disputationi vim in, mollis iriure nec cu, alienum argumentum ius ad. Pri eu justo aeque torquatos.Lorem ipsum dolor sit amet, mel at clita quando. Te sit oratio vituperatoribus, nam ad ipsum posidonium mediocritatem, explicari dissentiunt cu mea. Repudiare disputationi vim in, mollis iriure nec cu, alienum argumentum ius ad. Pri eu justo aeque torquatos.Lorem ipsum dolor sit amet, mel at clita quando. Te sit oratio vituperatoribus, nam ad ipsum posidonium mediocritatem, explicari dissentiunt cu mea. Repudiare disputationi vim in, mollis iriure nec cu, alienum argumentum ius ad. Pri eu justo aeque torquatos.Lorem ipsum dolor sit amet, mel at clita quando. Te sit oratio vituperatoribus, nam ad ipsum posidonium mediocritatem, explicari dissentiunt cu mea. Repudiare disputationi vim in, mollis iriure nec cu, alienum argumentum ius ad. Pri eu justo aeque torquatos.Lorem ipsum dolor sit amet, mel at clita quando. Te sit oratio vituperatoribus, nam ad ipsum posidonium mediocritatem, explicari dissentiunt cu mea. Repudiare disputationi vim in, mollis iriure nec cu, alienum argumentum ius ad. Pri eu justo aeque torquatos.Lorem ipsum dolor sit amet, mel at clita quando. Te sit oratio vituperatoribus, nam ad ipsum posidonium mediocritatem, explicari dissentiunt cu mea. Repudiare disputationi vim in, mollis iriure nec cu, alienum argumentum ius ad. Pri eu justo aeque torquatos.Lorem ipsum dolor sit amet, mel at clita quando. Te sit oratio vituperatoribus, nam ad ipsum posidonium mediocritatem, explicari dissentiunt cu mea. Repudiare disputationi vim in, mollis iriure nec cu, alienum argumentum ius ad. Pri eu justo aeque torquatos.`
   }),
   methods: {
     checkAmount(){

       if(!this.amount) {
         return true;
       }

       if(this.amount > (this.selectedSavings.targetAmount - this.savings.currentAmount)){
         return 'Deposit more than remaining amount';
       } else if (this.amount.includes('-') || this.amount.includes('+') || this.amount[0] === '0' || !this.amount){
         return 'Please enter a valid input';
       } else {
         return true;
       }
     },
     update() {

       let payload = {
         _id: this.savings._id,
         name: this.savings.name,
         type: this.transactionType,
         amount: this.amount,
         transactionCode: this.transaction
       }


       this.$store.dispatch('updateSavings', payload).then(() => {
         this.$refs.form.reset();
         // this.$emit('dismiss')
         this.updateDialog = false;
       });

     },
   deleteSavings() {
     this.$store.dispatch('delete',this.selectedSavings).then(() => {
       this.transactionsDialog = false;
     });
   },
   capitalize(text) {
     if (!text) return ''
     text = text.toString()
     return text.charAt(0).toUpperCase() + text.slice(1)
   },
   search(){
     this.searchBar = !this.searchBar;

     if(this.searchBar){
      this.transactionsOrig = this.transactions;
     } else {
       // After changing, if it's false
       this.transactions = this.transactionsOrig;
     }
   },
   downloadData: function(){
     this.$store.dispatch('downloadData');
   },
   uploadData: function(){
     return new Promise(resolve => {
       this.$store.dispatch('uploadData').then(() => {
         resolve('Done');
       });
     });
   },
   clearData: function(){
     this.$store.dispatch('clearData');
   },
   getSavings(saving){

     this.transactions = [...this.$store.getters.getTransactionsArray];
     this.savings = [...this.$store.getters.getSavingsArray];

     if(typeof saving === 'string'){
       let array = this.savings.filter(obj => {
         return obj.name === saving;
       })
       saving = array[0]
     }

     // console.log(saving);

     this.selectedSavings = saving;
     this.selectedTransactions = this.transactions.filter(obj => {
        return obj.name === saving.name;
     })

     this.transactionsDialog = true;
   },
   processChartObject(obj){
      // Takes chart object as argument

     // let newObject = this.observerClean(obj);

     console.log('Process chart called!!!');


     if(!obj){
       return;
     }


     this.advisoryArray = obj.advisoryArray;
     this.stackedArray = obj.stackedArray;

     console.log(this.advisoryArray);
     console.log(this.stackedArray);


     if(this.advisoryArray){
       this.chartData =  {
         labels: [...this.names],
         series: [[...this.advisoryArray],[...this.stackedArray]]
       }
     } else {
       return
     }

     let currents = [];
     let targets = [];
     let percentages = [];

     let inputsArray = this.$store.getters.getInputsArray;

     console.log(inputsArray)

     for(let i=0; i<inputsArray.length; i++) {
       if(i % 2 === 0) { /// Even
         currents.push(inputsArray[i]);
       } else {/// Odd
         targets.push(inputsArray[i]);
         percentages.push(Math.round(inputsArray[i-1] / inputsArray[i] * 100));
       }
     }


     let currentTotals = currents.reduce((a, b)=> a + b);
     let currentTargets = targets.reduce((a, b)=> a + b);

     let adviseObj = [];
     let namesArray = this.$store.getters.getNamesArray;

     for(let i=0;i<(inputsArray.length/2);i++){

       let innerObject = {
         name: namesArray[i],
         current: inputsArray[i * 2],
         target:  inputsArray[i * 2 + 1],
         percentage: percentages[i],
         adviseType: obj.typeArray[i],
         adviseAmount: obj.stackedArray[i] * inputsArray[i * 2 + 1]
       }

       innerObject = JSON.parse(JSON.stringify(innerObject));

       adviseObj.push(innerObject)
     }

     let plan = this.$store.getters.getCurrentPlan;


     let Thisobj = {
       currentTotals,
       currentTargets,
       total: obj.total,
       plan
     }

     this.total = Math.round(Thisobj.total);

     this.summaryComponent = JSON.parse(JSON.stringify(Thisobj));
     this.adviseObject = adviseObj;

     console.log(this.adviseObject);
     console.log(this.summaryComponent);
     console.log(this.savings);
     this.savings = [...this.$store.getters.getSavingsArray]
   },
   percentify(a,b) {
     return Math.round((Number(a)/Number(b))*100);
   },
   numberfy(a) {
     return Math.round(Number(a));
   },
   uppercase(text) {
     if (!text) return ''
     text = text.toString()
     return text.toUpperCase()
   },
   capitalize(text) {
     if (!text) return ''
     text = text.toString()
     return text.charAt(0).toUpperCase() + text.slice(1)
   },
   dismiss () {
     this.$store.dispatch('changeLoadAction')
     // this.clicked = true //// Where the error is!!!!
     },
   dismissTransaction () {
     this.transactionsDialog = false;
   },
   updateTransaction () {
     this.transactionsDialog = false;
     this.updateDialog = true;
   },
   dismissUpdate () {
       this.$refs.form.reset();
     this.updateDialog = false;
   },
   add() {
     let isValid = this.$refs.form.validate();
     if(!isValid) {
       this.$store.dispatch('showDialog',{type: 'messageOnly', message: 'Please fill the form correctly'});
       return;
     }

     let submitObject = null;
     if(this.radioGroup === undefined){
       submitObject = {
         title: this.title,
         target: this.target,
         startingValue: this.startingValue,
         choice: ' '
       }
     } else {
       submitObject = {
         title: this.title,
         target: this.target,
         startingValue: this.startingValue,
         choice: this.radioGroup
       }
     }


     if(Number(submitObject.target) < Number(submitObject.startingValue)) {
       this.$store.dispatch('showDialog',{type: 'messageOnly', message:
           'Your starting value cannot be more than your goal'});
       // console.log(submitObject);
       return;
     }

     this.$refs.form.reset();
     this.addDialog = false;

     if(this.radioGroup === ''){
       submitObject.choice = this.$store.getters.getCurrentPlan;
     } else {
       this.$store.dispatch('adjustPlan', submitObject.choice);
     }

     //// Put the savings to the database

     this.$store.dispatch('addSavings', submitObject);
   },
   cancel(){
     this.$refs.form.reset();
     this.addDialog = false;
   },
   logout () {
     this.$store.dispatch('showDialog',{type: 'messageOnly', message: 'Housekeeping...'});
     this.uploadData().then(() => {
       this.$store.dispatch('logout').then(() => {
         this.$store.dispatch('stopLoading').then(() => {
           router.push({name: 'login'})
         });
       })
     });
   },
   switchDialog () {
     this.addDialog = !this.addDialog
     this.guideDialog = !this.guideDialog
   },
   stageStatus () {
     this.$store.dispatch('inStage2')
   },

   docDefinition1() {
     let resultArray = [];

     for (let i = 0; i < this.transactions.length; i++) {
       let header;
       let TransactionStatement;
       let prev;
       let current;
       let total;

       let transactionStat = this.transactions[i];

       // First Row first part
       let statementStyle;
       if (
         (transactionStat.transactionType === 'first deposit' && transactionStat.current === '0') ||
         transactionStat.transactionType === 'removed'
       ) {
         header = transactionStat.name;
         TransactionStatement = '';
         prev = '';
       } else {
         if (
           transactionStat.transactionType === 'deposit' ||
           transactionStat.transactionType === 'first deposit'
         ) {
           statementStyle = 'greenText';
         } else {
           statementStyle = 'redText';
         }

         header = `${transactionStat.name} ${transactionStat.transactionType}`;
         TransactionStatement = `${transactionStat.transactionType} of ${transactionStat.transactionAmount}`;

         current = `Current:${transactionStat.current}`;
         total = `Target:${transactionStat.target}`;
         prev = `Prev: ${transactionStat.prev}` + ' ' + current + ' ' + total;
       }

       let row1 = {
         text: `${header} as of ${transactionStat.transactionDate} `,
         style: 'TransactionName'
       };

       let row2 = {
         text: TransactionStatement,
         style: statementStyle
       };

       let transactionID;

       if (transactionStat.transactionID === 'noID') {
         transactionID = '';
       } else {
         transactionID = transactionStat.transactionID;
       }

       let row3 = {
         text: transactionID,
         style: 'RestText'
       };

       let row4 = {
         text: prev,
         style: 'RestText'
       };

       let row5 = {
         text: ' ',
         style: 'RestText'
       };

       resultArray.push(row1, row2, row3, row4, row5);
     }

     return {
       content: [ { text: `Transactions  ${new Date().toLocaleDateString()}`, style: 'header' }, ...resultArray ],
       styles: {
         header: {
           fontSize: 17,
           bold: true,
           color: '#0055D4'
         },
         TransactionName: {
           fontSize: 12,
           color: '#222'
         },
         RestText: {
           fontSize: 10,
           color: '#868787'
         },
         blueText: {
           color: '#0055D4'
         },
         redText: {
           color: 'red'
         },
         greenText: {
           color: 'limegreen'
         }
       }
     };
   },
   docDefinition2() {
       let spreadArray = [];

       let bigObject = this.adviseObject;

       for (let i = 0; i < bigObject.length; i++) {
         let rowArray = [];

         rowArray = [
           { text: `${bigObject[i].name}`, style: 'sideTitle' },
           { text: `${Math.round(bigObject[i].percentage)}%`, style: 'sideValues' }
         ];

         let adviseArray;

         let advise = ' ';

         let adviseType = '';

         if (bigObject[i].adviseType === 'Deposit') {
           advise = `You need to deposit ${Math.round(bigObject[i].adviseAmount)} to reach the target`;
           adviseType = 'greenText';
         } else if (bigObject[i].adviseType === 'Withdraw') {
           advise = `You have exceeded your limit by ${Math.round(bigObject[i].adviseAmount)}`;
           adviseType = 'redText';
         }

         adviseArray = [ { text: advise, style: adviseType }, { text: ' ' } ];

         spreadArray.push(rowArray);
         spreadArray.push(adviseArray);
       }

       return {
         content: [
           {
             table: {
               headerRows: 1,
               body: [
                 [ { text: 'Active Savings', style: 'tableHeader' }, { text: ' ', style: 'tableHeader' } ],
                 ...spreadArray,
                 [
                   { text: 'Current Percentage', style: 'sideTitle' },
                   { text: `${Math.round(this.summaryComponent.total)}%`, style: 'blueText' }
                 ],
                 [
                   { text: 'Total of Current Savings', style: 'sideTitle' },
                   { text: `${this.summaryComponent.currentTotals}`, style: 'blueText' }
                 ],
                 [
                   { text: 'Total of Target Savings', style: 'sideTitle' },
                   { text: `${this.summaryComponent.currentTargets}`, style: 'greenText' }
                 ],
                 [
                   { text: 'Current Plan', style: 'sideTitle' },
                   { text: `${this.summaryComponent.plan.toUpperCase()}`, style: 'redText' }
                 ]
               ]
             },
             layout: 'noBorders'
           }
         ],
         styles: {
           tableHeader: {
             fontSize: 17,
             bold: true,
             color: '#0055D4'
           },
           sideTitle: {
             color: '#868787'
           },
           sideValues: {
             color: '#868787'
           },
           sideAdvise: {
             fontSize: 10,
             color: 'red'
           },
           blueText: {
             color: '#0055D4'
           },
           redText: {
             color: 'red'
           },
           greenText: {
             color: 'limegreen'
           }
         }
       };
     },

  downloadTransactions(){
    if(this.names.length === 0){
      this.$store.dispatch('showDialog',{type: 'messageOnly', message: 'No data to download yet'});
      return;
    }

    let pdfObject = pdfMake.createPdf(this.docDefinition1());
    pdfObject.download();
  },

  downloadAdvise(){

   if(this.names.length === 0){
     this.$store.dispatch('showDialog',{type: 'messageOnly', message: 'No data to download yet'});
     return;
   }

   let pdfObject = pdfMake.createPdf(this.docDefinition2());
   pdfObject.download();
 }

   },
   watch: {
       searchValue: function(value){

         this.transactions = this.transactions.filter((obj) => {
           // console.log(obj.transactionAmount);
           // console.log(this.searchValue);
           // console.log(obj.name.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1);
           return (
             obj.name.toLowerCase().indexOf(this.searchValue.toLowerCase()) > -1 ||
             obj.transactionType.toLowerCase().indexOf(this.searchValue.toLowerCase()) > -1 ||
             obj.transactionID.toLowerCase().indexOf(this.searchValue.toLowerCase()) > -1 ||
             obj.transactionAmount.includes(this.searchValue) ||
             obj.transactionDate.indexOf(this.searchValue) > -1
           );
         });

         // console.log(!value);
         if(!value){
           this.transactions = this.transactionsOrig;
         }

       },
       themeSwitch: function(value) {
         // console.log(value)
         if(this.settingsRadios !== ''){
           this.$store.dispatch('changeTheme', value);
         }
           console.log('SETTINGS: Theme switch initialized');
       },
       settingsRadios: function(value) {
         console.log(value)
         if(this.settingsRadios !== ''){
           this.$store.dispatch('changePlan', value);
         }
         console.log('SETTINGS: Plan Radios initialized');
       },
     loadStatus: function(loadStatus) {
       this.type = this.$store.getters.getType;
       this.message = this.$store.getters.getMessage;
       this.dialog = loadStatus;
     },
     getSavingsArray: function(savingsArray) {
       console.log('This is the savings array',savingsArray);
       this.savings = savingsArray;
     },
     getTransactionsArray: function(transactionArray) {
        // console.log(transactionArray);
        this.transactions = transactionArray;
       this.transactions = this.transactions.reverse()

     },
     getCurrentPlanIsSet: function(isSet){
       // Updates this on Change
       this.planIsSet = isSet;
     },
     getCurrentPlan: function(plan){
       // Updates this on Change
       // this.planIsSet = isSet;
       this.currentPlan = plan;
       this.currentPlan = this.currentPlan.toUpperCase();
       this.settingsRadios = plan;

     },
     getChartObject: function(chartObject){
       // Updates this on Change
       // console.log(chartObject);

       if(!chartObject || chartObject.advisoryArray.length === 0){
         this.names = [];
         this.advisoryArray = [];
         this.stackedArray = [];
         this.chartObject = {};
         this.selectedSavings = '';
         this.selectedTransactions = '';
         this.names = [];
         this.adviseObject = [];
         this.summaryComponent = {};
         this.savings = {};
         this.transactions = [];
         this.chartData = {
           labels: [''],
           series: [[0],[0]]
         };
         console.log(this.$chartist);


         return
       }

       this.chartObject = chartObject;
       this.processChartObject(chartObject);
     },
     getNamesArray: function(names){
       this.names = [...names];
       // console.log(names);
       this.chartData =  {
         labels: [...this.names],
         series: [[...this.advisoryArray],[...this.stackedArray]]
       }
     },
     getCurrentTheme: function (value){
       this.themeSwitch = value;
       this.isLight = value;
     }
   },
   computed: {
     ...mapGetters([
       'loadStatus',
       'getSavingsArray',
       'getTransactionsArray',
       'getCurrentPlanIsSet',
       'getCurrentPlan',
       'getChartObject',
       'getNamesArray',
       'getCurrentTheme'
     ]),
     events: function() {

       var globalThis = this;

       return [{
       event: 'draw',
       fn: (obj) => {
         // console.log('fn', this);
         if (obj.type === 'bar') {
           obj.element._node.onclick = function(resp) {
             // console.log(obj.axisX.ticks[obj.index]);
             let name = obj.axisX.ticks[obj.index];
             // let rObj = thisGlobal.dataTransfer.savingsParser2(name);
             // thisGlobal.statPressed(name);
             // console.log(name);
             // this.getSavings(name);
             globalThis.getSavings(name);
             // console.log(globalThis);
           };
         }
       }
     }]},
     titleCheck: function(){

       if(!this.title || this.names.length === 0){
         return true;
       }


       var toLower = function(x){
         return x.toLowerCase();
       };

       let lowercaseNames = this.names.map(toLower);


       if(lowercaseNames.indexOf(this.title.toLowerCase()) !== -1){
          return 'Already exists';
       } else if(this.title === '' || !this.title){
         return 'Title required';
       } else if (this.title.includes(' ')) {
         return 'Spaces are not allowed';
       } else if (!/^[a-zA-Z_\-]+$/.test(this.title)){
         return 'Numbers not allowed';
       } else {
         return true;
       }


     }
   },
   mounted () {
      this.stageStatus();


      this.$store.dispatch('loadData').then((data) => {
        // Sets the is set early enough
        console.log(data);

        this.planIsSet = this.$store.getters.getCurrentPlanIsSet;

        if(this.planIsSet) {
          this.currentPlan = this.$store.getters.getCurrentPlan;
          this.currentPlan = this.currentPlan.toUpperCase();
          //Get adviseObject
          this.settingsRadios = this.$store.getters.getCurrentPlan;
        }

        this.themeSwitch = this.$store.getters.getCurrentTheme;
        this.isLight = this.$store.getters.getCurrentTheme;
        // Get transactions and savings
        this.savings = this.$store.getters.getSavingsArray;
        this.transactions = this.$store.getters.getTransactionsArray;
        this.transactions = this.transactions.reverse();
        this.names = this.$store.getters.getNamesArray;
        // Get transactions and savings

        //Get adviseObject
        let LadviseObject = this.$store.getters.getChartObject;
        this.processChartObject(LadviseObject);
        this.chartObject = LadviseObject;
        // Sets the is set early enough

        const uid = firebase.auth().currentUser.uid;
        // console.log(uid);
        this.$store.dispatch('setUID', uid);

        /// Deal with caching of data
        this.$store.dispatch('fetchInfo').then(info => {
          console.log(info);
        });

        this.$store.dispatch('downloadData');

      })

   }
 }







</script>

<style lang="scss" scoped>

  .darkCardTheme {
    background-color: #282828 !important;
    color: #0055D4 !important;

    .v-card {
      background-color: #282828 !important;
      color: #0055D4 !important;
    }

     .label, p {
      color: #0055D4 !important;
    }

    .label, .greyText .v-input {
      color: #0055D4 !important;

    }




  }
  .lightCardTheme {}


  .darkTheme {
    background-color: #222;

    .v-card {
      background-color: #282828 !important;
    }

    .ct-label {
      color: #0055D4 !important;
    }
    .ct-grids {
      opacity: 0.8 !important;
      color: white !important;
    }

    .greyText, .lowerCardHeader, .darkGreyText {
      color: #0055D4 !important;
    }

    .lowerCardBody::-webkit-scrollbar-track
    {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
      background-color: #282828;
    }

    .lowerCardBody::-webkit-scrollbar
    {
      width: 10px;
      background-color: #484848;
    }

    .lowerCardBody::-webkit-scrollbar-thumb
    {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
      background-color: rgba(255,255,255,0.2);
    }

  }

  .lightTheme {
    background-color: white;

  }


.searchBarDiv {
  height: 60px;
}



>>>.ct-bar {
  cursor: pointer !important;
}


.sidebar {
  height: 60px;
  /* width: 100vw; */
  background-color: aqua;
  position: relative;
}

.mainbar {

}

.guidePic {
  height: 110px;
  margin-top: 10px;
}

.topCard {
 height: calc(220px + 1.5vh)
}

.card {
  height: 43vh;
}

.logoTitle {
  color: #0055D4;
}

.guideHeader {
  width: 100%;
  /*background-color: brown;*/
  position: relative;
}
.guideBody {
  width: 100%;
}

.lastHeader {
  /*background-color: blue;*/
  position: absolute;
  right: 0;
  top: 0;
}
.guideIcon {
  font-size: 23px !important;
  color: #0055D4;
}

.guideIcon:active {
  color: white !important;
}

.guideBody .container {
  padding-top: 0 !important;
  overflow-y: hidden;
}

.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 95%;
}

.greyText {
  color: grey;
}



.dialogTitle {
color: #0055D4;
}

>>> .accent--text {
  color: #0055D4 !important;
}


.addBufferDialog >>> .v-card__title {
  padding-bottom: 0 !important;
}

.addBufferDialog >>> .v-card__text {
  padding-top: 0 !important;
}

.insideCard {
  height: 100%;
  width: 100%;
}

.helper p{
   color: grey;

}

.helper p:hover{
   color: red;
}

.helper p:active{
   color: white;
}


.lowerCard {
  /* background-color: green; */
  width: 50px;
}

.firstIcons {
 float:left;
}

.icons {
  font-size: 35px;
  color: #0055D4;
}

.icons:hover {
  font-size: 36px;
  color: red;
}

.icons:active {
  color: white;
}


.lastIcons {
float:right;
}

.calendarArea {
  width: 100%;
}

.realCalendar {
  width: 100%;
}

.realCalendar >>> .v-picker__body {
   width: 100% !important;
}

.realCalendar >>> .v-date-picker-title {
  color: #3E50B4
}

.cardHeader {
  background-color: #3E50B4;
  height: 30px;
  width: 100%;
  display: inline-block;
}

.cardHeaderFirstCard {
  height: 30px;
  width: 100%;
  /* background-color: red; */
}

.firstFlex {
  height: 200px;
}



.divContainer {
  height: 100%;
  width: 100%;
  display: inline-block;
}

.leftPart {
   float: left;
   /*background-color: red;*/
}

.circle:before {
  content: ' \25CF';
  font-size: 25px;
  color: #0055D4;
}

.circle1:before {
  content: ' \25CF';
  font-size: 25px;
  color: red;
}

.rightPart {
  margin-top: 10px;
  float: right;
  /*background-color: green;*/
}

.bigText {
  font-size: 1.4em;
}

.mediumText {
  font-size: 1.2em;
}

.smallText {
  font-size: 1em;
}




.greenText {
  color: limegreen;
}

.blueText {
  color: #0055D4;
}

.redText {
  color: red;
}

.darkGreyText {
  color: #868787;
}

.greyText {
  color: #868787;
}

.chartArea {
  margin-top: 10px;
}

.firstCardTitle {
  float:left;
  margin-left: 20px;
  font-size: 1.4em;
  font-weight: 400;
  margin-top: 7px;
}

@media only screen and (max-width: 400px) {
  .firstCardTitle {
    font-size: calc(4.2vw);
    font-weight: 500;
  }
}

.firstCardTitleLower {
  float:left
}

.cardHeaderFirstCardLower {
  height: 35px;
  width: 100%;
  -webkit-box-shadow: 0 4px 4px -2px #d6d6d6ea;
   -moz-box-shadow: 0 4px 4px -2px #d6d6d6ea;
        box-shadow: 0 4px 4px -2px #d6d6d6ea;
}

.lowerCardBody {
  height: calc(100% - 35px);
  width: 100%;
  overflow-y: auto;
  position: absolute;
}

.lowerCardBody::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: #F5F5F5;
}

.lowerCardBody::-webkit-scrollbar
{
  width: 10px;
  background-color: #F5F5F5;
}

.lowerCardBody::-webkit-scrollbar-thumb
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  background-color: rgba(255,255,255,0.2);
}

.savingsDiv, .transactionsDiv {
  margin-bottom: 10px;
  display: block;
  cursor: pointer;
}

.fullWidth {
  width: 100%;
  /*background-color: red;*/
  display: inline-block;
}

.athird {
  width: calc(100%/3);
  float: left;
}

.floatLeft {
  float: left;
}

.floatRight {
  float: right;
}


.plusIcon {
   color: #0055D4;
   font-size: 28px;
   margin-top: 10px;
}

.cardIcon {
 color: #0055D4;
 font-size: 24px;

}

.cardIcon:hover {
  color: red;
}

.cardIcon:active {
  color: white;
}

.lowerCardHeader {
  font-size: 1.5em;
  margin-left: 12px;
  color: #868787;
}


.plusIcon:hover {
  font-size: 34px;
  color: red;
}

.plusIcon:active {
  color: white;
  font-size: 32px;
}

.addArea {
  float: right;
}



.headerPart1 {
  float: left;
}

.headerPart2 {
  float: right;
  margin-top: 6px;
  margin-right: 6px;
}

.iconHeader {
  font-size: 19px;
  color: white;
  cursor: pointer;
}

.iconMarginRight {
  margin-right: 7px;
}

.title {
  padding: 0;
  padding-top: 6px;
  margin-left: 6px;
  color: white;
  font-size: calc(12px + 0.5vw) !important;
}

.below {
  position: absolute;
  bottom: 10px;
  width: 100%;
  text-align: center;
}

.avatarDiv {
  width: 100%;
  text-align: center;
  margin-top: 20px;
}

.icon {
  font-size: 36px;
  color: #3E50B4;
  float: left;
  width: 100%;
}

.iconTop {
  margin-bottom: 30px;
}

.touchable {
  cursor: pointer;
}

.touchable:hover {
  height: 53px !important;
  width: 53px !important;
}

.touchable:active {
  height: 48px !important;
  width: 48px !important;
}

.icon:hover {
  color: red;
}

.cardInDialog {
  /* width: 100%;
  height: 100%; */
  /* display: list-item; */
  text-align: center;
  background-color: white;
}

.notificationsDiv {
  height: 40px;
}

.titleLeft {
  text-align: center;
}

.planArea {
  height: 180px;
  padding: 0 23px;
}

.radioGroup {
  width: 100%;
  display: block;
}

.full {
  width: 100%;
  height: 32px;

}

.content {
  margin-bottom: 60px;
}

.fullHint {
  width: 100%;
  text-align: left;
  font-size: 18px;
  margin-top: 10px;
}

.toRight {
  float:right;
}

.toLeft {
  float: left;
}

.inputArea {
  width: 100%;
}

.profileInputs {
  width: 80%;
  margin: auto;
}

.label {
  float: left;
  margin-left: 17px;
  font-size: 17px;
}

.switch {
  float: right;
}

.innerSwitch {
  padding: 0;
  margin-top: 0;
}

.divider {
  color: rgba(41, 6, 6, 0.23);
}

.buttons {
  margin: auto;
}

.profileAvatar {
  width: 100%;
  text-align: center;
}

.profileAv {
  margin: auto;
}

.textAlignLeft {
  text-align: left;
}

  .transactionDialog .fullWidth {
    width: 100%;
    /*background-color: red;*/
    margin-bottom: 10px;
    display: inline-block;
  }
  .transactionDialog .bigTitle {
    font-size: 1.3em;
    font-weight: 500;
  }

  .transactionDialog .titleText {
    font-size: 1.2em;
  }

  .transactionDialog .answerText {
    font-size: 1em;
  }


  .transactionDialog .greyText {
    color: #868787;
  }

  .transactionDialog .greenText {
    color: limegreen !important;
  }

  .transactionDialog .blueText {
    color: #0055D4 !important;
  }

  .transactionDialog .redText {
    color: red;
  }

  .transactionDialog .aThirdRow {
    /*display: inline-block;*/
  }

  .transactionDialog .aThird {
    width: calc(100%/3);
    float: left;
  }

  .transactionDialog .floatLeft {
    float: left;
    width: 50%;
  }

  .transactionDialog .floatRightAdjustment {
    text-align: right !important;
  }

  .transactionDialog .floatRight {
    text-align: right;
    float: right;
    width: 50%;
  }


  .alertDialog .v-card {
    background-color: white;
    text-align: center;
  }

  .alertDialog .v-progress-circular {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .alertDialog p {
    font-size: 1.3em;
    color: blue;
  }


  .updateDialog .v-radio {
    margin-right: 0 !important;
  }

  .updateDialog .greyText {
    color: #868787;
  }

  .updateDialog .inputWidth {
    width: 70%;
  }

  .updateDialog .notificationsDiv {
    height: 60px;
  }

  .updateDialog .radioGroup {
    width: 100%;
    display: block;
  }

  .updateDialog .full {
    width: 100%;
    height: 32px;
  }

  .updateDialog .toRight {
    float:right;
  }

  .updateDialog .toLeft {
    float: left;
  }


  .infoCard {
    padding: 20px !important;
  }

  .infoCard .infoArea {
    user-select: none;
  }

  .infoCard span {
    cursor: default;
  }

  .infoCard .logosArea{
    width: 100%;
    height: 20%;
    text-align: center;
  }

  .infoCard img {
    margin: 0 10px;
  }

  .infoCard #vue{
    height: 40px;
    width: auto;
  }

  .infoCard #electron {
    height: 50px;
    width: auto;
  }

  .infoCard .firebase {
    height: 50px;
    width: auto;
  }

  .infoCard #vuetify {
    height: 40px;
    width: auto;
  }

  .infoCard .paragraph{
    width: 100%;
    text-align: center;
  }

  .infoCard .title {
    font-weight: 500;
    color: #3E50B4;
  }

  .infoCard .blueText {
    color: #3E50B4;
  }

  .infoCard .vueText {
    color: rgb(65,184,131);
  }

  .infoCard .vuetifyText {
    color: rgb(32,150,243);
  }

  .infoCard .electronText {
    color: rgb(152,218,230);
  }

  .infoCard .firebaseText {
    color: rgb(255,204,48);
  }

  .infoCard .faceBookLink {
    cursor: pointer;
    text-decoration: none;
    outline: none !important;
  }

  .infoCard .faceBookLink:hover {
    font-weight: bold;
  }

  .infoCard .faceBookLink:active {
    color: white;
  }

  .infoCard .title2 {
    font-weight: bold;
    font-size: 1.2em;
  }

  .infoCard .smallerText {
    font-weight: bold;
    font-size: 0.8em;
  }






</style>




// WEBPACK FOOTER //
// src/components/Authenticated/Homepage.vue